export default {
  STATE_ADD_TO_BLOCKLIST: 'STATE_ADD_TO_BLOCKLIST',
  STATE_REMOVE_FROM_BLOCKLIST: 'STATE_REMOVE_FROM_BLOCKLIST',
  STATE_ADD_TO_ALLOWLIST: 'STATE_ADD_TO_ALLOWLIST',
  STATE_REMOVE_FROM_ALLOWLIST: 'STATE_REMOVE_FROM_ALLOWLIST'
};